import { UserAccessPermissions } from "./UserAccessPermissions";

export class GetPermissionResult {
  public success: boolean;
  public error: boolean;
  public errorMessage: string;
  public permissionList: UserAccessPermissions[];

  constructor(
    success: boolean = false,
    error: boolean = false,
    errorMessage: string = '',
    permissionList: UserAccessPermissions[] = []
  ) {
    this.success = success;
    this.error = error;
    this.errorMessage = errorMessage;
    this.permissionList = permissionList;
  }
}
